$(function () {
	const $validator = jQuery.validator;
	var errorPrefix = i18n('js_error') + ': ';
	usernameUniqueMessage = "This username has been taken";
	var lastCheckedUsernameValue = {name: null, success: true };
	if(typeof($validator)!='undefined') {

	    // email update to allow '&' symbols for JCT
        $.validator.methods.email = function( value, element ) {
            return this.optional( element ) || /^(['_a-zA-Z0-9-&]+)(\.['_a-zA-Z0-9-&]+)*@([a-zA-Z0-9-]+)(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,24})$/.test( value );
        }

        $.validator.addMethod("phoneUS", function(phone_number, element) {
            phone_number = phone_number.replace(/\s+/g, "");
            return this.optional(element) || phone_number.length > 9 &&
                phone_number.match(/^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/);
        }, "Please enter a valid US phone number in the format 555-555-5555");
        $.validator.addMethod("zipcodeUS", function(value, element) {
            return this.optional(element) || /^\d{5}(-\d{4})?$/.test(value);
        }, "Please enter a valid US zip code");		

		//date functions
		$.validator.addMethod("datepicker", function(value, element) {

            if (this.optional(element)) {
                return true;
            }

            // Am I not actually a datepicker?
            if (!$(element).hasClass('hasDatepicker')) {
                return true;
            }

            //check date
            return ele.date.isValidDate(value);

		}, errorPrefix + i18n("js_valid_date", {dateformat: ele.config.usersession.dateformat}));

		$.validator.addMethod("datepickerForceUKFormat", function(value, element) {
            if (this.optional(element)) {
                return true;
            }

            // If I am not a datepicker.
            if (!$(element).hasClass('hasDatepicker')) {
                return true;
            }

            //check date
            return ele.date.isValidDate(value, 'dmy');

		}, errorPrefix + i18n("js_valid_date", {dateformat: ele.config.usersession.dateformat}));

		$.validator.addMethod(
			"notDefaultValue",
			function (value, element, defaultValue) {
				return value !== defaultValue; // Ensure the value is not the default
			},
			errorPrefix + i18n('js_invalid_selection') // Custom error message
		);

		$.validator.addMethod("dateMin", function(value, element, param) {

            if (this.optional(element)) {
                return true;
            }
            if (!ele.date.isValidDate(value)) {
                return false;
            }

            // Convert user input to a common date format
            let userEnteredDate;
            let dateSplit = value.split('/');
            if (ele.date.isUSDate()) {
                userEnteredDate = new Date(`${dateSplit[2]}-${dateSplit[0]}-${dateSplit[1]}`)
            } else {
                userEnteredDate = new Date(`${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`)
            }

            // were we provided a date? Otherwise use today
            let minDate = param;
            if (!minDate instanceof Date) {
                minDate = new Date(new Date(Date.now())).setHours(0,0,0,0);
            }
			// Compare the dates
		    return (userEnteredDate.withoutTime() >= minDate.withoutTime());

		}, $.validator.format(errorPrefix + i18n("js_valid_date_after")));

		$.validator.addMethod("isPossibleDate", function(value, element, param) {
            return ele.date.isValidDate(value, 'dmy', true);
		}, $.validator.format(errorPrefix + i18n("js_select_valid_date")));	

		$.validator.addMethod("dateMax", function(value, element, param) {
			if (this.optional(element)) {
		        return true;
		    }
            if (!ele.date.isValidDate(value)) {
                return false;
            }
            let userEnteredDate;
			
            let dateSplit = value.split('/');
            if (ele.date.isUSDate()) {
                userEnteredDate = new Date(`${dateSplit[2]}-${dateSplit[0]}-${dateSplit[1]}`)
            } else {
                userEnteredDate = new Date(`${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`)
            }
            if (isNaN(userEnteredDate)) {
                return false;
            }
            // were we provided a date? Otherwise use today
            let maxDate = param;
            if (!maxDate instanceof Date) {
                maxDate = new Date(new Date(Date.now())).setHours(0,0,0,0);
            }
		    return (maxDate.withoutTime() >= userEnteredDate.withoutTime());
		}, $.validator.format(errorPrefix + i18n("js_valid_date_before")));

		$.validator.addMethod("dateMaxForceUKFormat", function(value, element, param) {
			if (this.optional(element)) {
		        return true;
		    }
            if (!ele.date.isValidDate(value, 'dmy')) {
                return false;
            }
            let userEnteredDate;
			
            let dateSplit = value.split('/');
            userEnteredDate = new Date(`${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`)
            if (isNaN(userEnteredDate)) {
                return false;
            }
            // were we provided a date? Otherwise use today
            let maxDate = param;
            if (!maxDate instanceof Date) {
                maxDate = new Date(new Date(Date.now())).setHours(0,0,0,0);
            }
		    return (maxDate.withoutTime() >= userEnteredDate.withoutTime());
		}, $.validator.format(errorPrefix + i18n("js_valid_date_before")));

		//matching Coldfusion field
		$.validator.addMethod("noSpecialChars", function(value, element) {
			return this.optional(element) || /^[A-Za-zÀ-ÿ0-9&()@#:.,\/\?\+!\*\s'_\-]+$/i.test(value);
		}, errorPrefix + i18n("js_valid_chars"));
		//Alphanumeric
		$.validator.addMethod("alphanumeric", function(value, element) {
			return this.optional(element) || /^\w+$/i.test(value);
		}, errorPrefix + i18n("js_valid_chars_simple"));

		$validator.addMethod("username", function( value, element ) {
			return this.optional( element ) || ( value.search( /^[a-z0-9][a-z0-9!-#$%&'/=?^_`{|}~+@.*-]*$/i ) != -1 );
		}, errorPrefix + i18n("js_valid_chars_username"));

		$validator.addMethod("phoneNumber", function(value,element){
			return this.optional(element)||(value.search(/^[+04][0-9 ]*([(][0-9]+[)])*[0-9 ]+$/)!=-1);
		}, errorPrefix + i18n("js_valid_chars_telephone"));

		$validator.addMethod("validateRap", function( value, element ) {
			return this.optional( element ) || ( value.search( /\.rap$/i ) != -1 );
		}, errorPrefix + "The file you selected is not a Rapidocs document (which must have a .rap filename extension)" );

        $validator.addMethod("notEqual", function(value, element, param) {
            return this.optional(element) || value !== $(param).val();
        }, errorPrefix + "This value must be different");

		var securityAnswerMessage="";
		$validator.addMethod("securityAnswer", function( value, element ) {
			// If security question is available, check against answer
			var securityQuestion=""; // value of security question field
			var pwCompare=""; // value of pw field
            var emailCompare=""; // value of email field
			if ( $("#RegisterFormCustomerPasswordChallenge").length ) { securityQuestion=$("#RegisterFormCustomerPasswordChallenge").val(); } // Registration form
			else if ( $("#CustomerPasswordChallenge").length ) { securityQuestion=$("#CustomerPasswordChallenge").val(); } // Change security question form
			else if ( $("#MyAccountFormCustomerPasswordChallenge").length ) { securityQuestion=$("#MyAccountFormCustomerPasswordChallenge").val(); } // Checkout My account after quick reg		
			if ( $("#RegisterFormCustomerPassword").length ) { pwCompare=$("#RegisterFormCustomerPassword").val(); } // Registration form
            if ( $("#RegisterFormCustomerEmail").length ) { emailCompare=$("#RegisterFormCustomerEmail").val(); } // Registration form
			else if ( $("#MyAccountFormPassword").length ) { pwCompare=$("#MyAccountFormPassword").val(); } // Checkout My account after quick reg
			// Run individual validations to match server side functions
			if ( value.length < 6 || value.length > 50 ) { securityAnswerMessage=i18n('js_valid_length_range', {min:6, max: 50}); }
			else if ( pwCompare.length && value.toLowerCase().indexOf(pwCompare.toLowerCase()) >=0 ) { securityAnswerMessage=i18n('js_valid_security_password'); }
            else if ( emailCompare.length && value.toLowerCase().indexOf(emailCompare.toLowerCase()) >=0 ) { securityAnswerMessage=i18n('js_valid_security_email_matched'); }
			else if ( securityQuestion.toLowerCase().indexOf(value.toLowerCase()) >=0 ) { securityAnswerMessage=i18n('js_valid_security_matched'); }
			else { securityAnswerMessage=""; }
			var securityAnswerOkay=(securityAnswerMessage.length>0)?false:true;
			$.validator.messages.securityAnswer=securityAnswerMessage;
			return this.optional( element ) || securityAnswerOkay;
		}, errorPrefix + securityAnswerMessage);

		$validator.addMethod("companyNameAllowedCharacters", function(value, element) {
			// The characters a-z0-9&amp;\(\)@#:\.,\/\?\+!\* '_- are allowed, any other characters are not allowed
			return this.optional(element) || /^[a-z0-9&amp;\(\)@#:\.,\/\?\+!\* '_-]+$/i.test(value);
		}, errorPrefix + i18n("js_valid_chars"));

        //when you're just asked to add a password to a login form
        /*$validator.addMethod("password", function( value, element ) {
            return this.optional( element ) || ( value.search( /^[a-z0-9]([a-z0-9_!\$\&%^*()@?#-]|\u00A3)*$/i ) != -1 );
        }, errorPrefix + i18n("js_valid_chars_password"));*/

        let passwordHighMessage=""; // error message
		$validator.addMethod("passwordCreate", function( value, element ) {

            passwordHighMessage=""; //reset

			// If username is available, check against password
			let pwUsernameCompare=""; // value of username field
            let pwUsernameCompareName="username"; // name to use for error message as email address is used on some quick reg forms

			if ( $("#RegisterFormCustomerLogin").length ) { pwUsernameCompare=$("#RegisterFormCustomerLogin").val().toString(); } // registration form
			if ( $("#changePwUn").length ) { pwUsernameCompare=$("#changePwUn").val().toString(); } // change password form
			if ( $("#customeremail").length ) { pwUsernameCompare=$("#customeremail").val().toString(); pwUsernameCompareName="email address"; } // contact form
			if ( $("#bulletin-email-field").length ) { pwUsernameCompare=$("#bulletin-email-field").val().toString(); pwUsernameCompareName="email address"; } // bulletin form
			if ( $("#QuickRegisterFormCustomerLogin").length ) { pwUsernameCompare=$("#QuickRegisterFormCustomerLogin").val().toString(); pwUsernameCompareName="email address"; } // R4 quick reg

            let breakdownEl = $('#CustomerPasswordBreakdown');
            breakdownEl.find('.validation-rule').removeClass("error");
            breakdownEl.find('.validation-rule').addClass("success");

            if (ele.commonPassword.contains(value)) {
                passwordHighMessage = i18n('js_valid_password_med_common');
            }
            if (value.toLowerCase() == pwUsernameCompare.toLowerCase()) {
                passwordHighMessage = i18n('js_valid_password_med_diff');
                if (pwUsernameCompareName == "email address") {
                    passwordHighMessage = i18n('js_valid_password_med_diff_email');
                }
            }
            if (value.toLowerCase() == pwUsernameCompare.toLowerCase()) {
                passwordHighMessage = i18n('js_valid_password_med_diff');
                if (pwUsernameCompareName == "email address") {
                    passwordHighMessage = i18n('js_valid_password_med_diff_email');
                }
            }
            if (value.search(/[0-9]+/i) < 0) {
                passwordHighMessage = i18n('js_valid_password_med_number');
                breakdownEl.find('#password_visual_validator_min_1_number_or_symbol').removeClass("success").addClass("error");
            }
            if (value.search(/[A-Z]/) < 0) {
                passwordHighMessage = i18n('js_valid_password_med_uppercase');
                breakdownEl.find('#password_visual_validator_min_1_upper_latin_letter').removeClass("success").addClass("error");
            }
            if (value.search(/[a-z]/) < 0) {
                passwordHighMessage = i18n('js_valid_password_med_lowercase');
                breakdownEl.find('#password_visual_validator_min_1_latin_letter').removeClass("success").addClass("error");
            }
            if (value.search(/[a-z]+/i) < 0) {
                passwordHighMessage = i18n('js_valid_password_med_letter');
            }
            if (value.length < 8 || value.length > 50) {
                passwordHighMessage = i18n('js_valid_length_range', {min: 8, max: 50});
                breakdownEl.find('#password_visual_validator_min_8_max_32_chars').removeClass("success").addClass("error");
            }

			var passwordOkay=(passwordHighMessage.length>0)?false:true;
			$.validator.messages.passwordCreate=errorPrefix + passwordHighMessage;
			return this.optional( element ) || passwordOkay;
		}, errorPrefix + passwordHighMessage);
		
		$validator.addMethod("otherPartyRequired", function( value, element ) {
			if ($("#otherPartyDetailsRequired").val() == 1 && value=='' ) {
				return false;
			}
			return true;
		}, errorPrefix + i18n("js_valid_other_party"));
	}

    ele.validations={};
	
	var d = new Date();
	d.setFullYear(d.getFullYear() - 18);
		
	// Add in rules (Can be overwritten in subsequent scripts before DOM load)
	// Not sure if they should be in a single file or in the individual components but as long as it's consistent I don't care.
	ele.validations.customer={
		ignore:".ignore",
		rules:{		
			CustomerFirstName:{required:true,rangelength:[2,255]},
			CustomerLastName:{required:true,rangelength:[2,255]},
			userfirstname:{required:true,rangelength:[2,255]},
			userlastname:{required:true,rangelength:[2,255]},
			CustomerAddress1:{required:true,rangelength:[5,255]},
			CustomerPostcode:{required:true,minlength:1,maxlength:10},
			CustomerTown:{required:true,minlength:1},
			CustomerLogin:{required:true,rangelength:[6,70],username:true,remote: function(element) {
                var username = $(element).val();
							
                // Check if the username is in the cache
                if (username === lastCheckedUsernameValue.name) {
                    // Return true to bypass remote validation
                    return lastCheckedUsernameValue.success;
                }

                // If not in the cache, perform remote validation
                return {
                    url: ele.uri.buildUrl('isusernameunique'),
                    type: "POST",
                    dataType: "json",
                    data: {
                        CustomerLogin: username
                    }
                };		
				}
			},
			username:{required:true,rangelength:[6,70],username:true,remote: function() {
                var username = $("#username").val();

                // Check if the username is in the cache
                if (username === lastCheckedUsernameValue.name) {
                    // Return true to bypass remote validation
                    return lastCheckedUsernameValue.success;
                }

                // If not in the cache, perform remote validation
                return {
                    url: ele.uri.buildUrl('isusernameunique'),
                    type: "POST",
                    dataType: "json",
                    data: {
                        CustomerLogin: username
                    }
                };		
				}
			},
			CustomerPassword:{required:true,passwordCreate:true},
			userpassword:{required:true,passwordCreate:true},
			CustomerConfirmPassword:{required:true,equalTo:':input[name="CustomerPassword"]'},	
			userpasswordconfirm:{required:true,equalTo:':input[name="userpassword"]'},					
			CustomerTelephone1:{phoneNumber:true,required:true,minlength:10,maxlength:20},
			CustomerTelephone2:{phoneNumber:true,minlength:10,maxlength:20},
			CustomerTelephone3:{phoneNumber:true,minlength:10,maxlength:20},
            CustomerCountryId:{countryIdValidator: true},
            JurisdictionId:{required: true},
            placeholder_CustomerTermsAccepted:{required: true,maxlength: 2},
			placeholder_UserTermsAccepted:{required: true,maxlength: 2},
			placeholder_NoticeAtCollectionAccepted:{required: true,maxlength: 2},
		    CustomerTermsAccepted:{required:true,maxlength: 2},
			UserTermsAccepted:{required:true,maxlength: 2},
		    CustomerEmail:{required:true,email: true},
			useremail:{required:true,email: true},
			TermsOfEngagement:{
				required: function(){
					if($('#RegisterFormTermsOfEngagementAccepted') != undefined){
						return true;
					} else {
						return false;
					}
				}  	
			},		            
			AddressSelectPostcodeField:{ required: false },
			CustomerDOB:{required: true,datepickerForceUKFormat: true,dateMaxForceUKFormat: d,isPossibleDate: true},
			DOBDay: { required: true },
			DOBMonth: { required: true },
			DOBYear: { required: true },
			CustomerPasswordChallenge:{required:true,rangelength:[1,100]},
            CustomerPasswordResponse:{required:true,securityAnswer:true,password:false},
            Password:{required:true,password:false}, //the password confirm on myAccount update
			CustomerCompanyEmployees:{number:true,min:0,max:99999},
			// Not required but must validate characters against a regex if provided
			CustomerCompanyName:{required:false,companyNameAllowedCharacters:true}
		},
		messages:{
			CustomerFirstName:{
			    required: errorPrefix + i18n("js_valid_firstname"),
                rangelength: errorPrefix + i18n("js_valid_firstname_range")
            },
			CustomerLastName:{
			    required: errorPrefix + i18n("js_valid_lastname"),
                rangelength: errorPrefix + i18n("js_valid_lastname_range")
			},
			userfirstname:{
			    required: errorPrefix + i18n("js_valid_firstname"),
                rangelength: errorPrefix + i18n("js_valid_firstname_range")
            },
			userlastname:{
			    required: errorPrefix + i18n("js_valid_lastname"),
                rangelength: errorPrefix + i18n("js_valid_lastname_range")
			},			
			CustomerCountryId: {
			    required: errorPrefix + i18n("js_valid_country")
            },
            JurisdictionId:{required: errorPrefix + i18n("js_valid_jurisdictionid")},
            customerAddress1:{
			    required: errorPrefix + i18n("js_valid_address"),
                rangelength: errorPrefix + i18n("js_valid_address_range")
            },
            CustomerTown:{required: errorPrefix + i18n("js_valid_town")},
            CustomerPostcode:{required: errorPrefix + i18n("js_valid_postcode")},
            CustomerTermsAccepted: {
                required: errorPrefix + i18n("js_valid_terms")
            },
			UserTermsAccepted: {
                required: errorPrefix + i18n("js_valid_terms")
            },
            placeholder_CustomerTermsAccepted: {
                required: errorPrefix + i18n("js_valid_terms")
            },
			placeholder_UserTermsAccepted: {
                required: errorPrefix + i18n("js_valid_terms")
            },
			placeholder_NoticeAtCollectionAccepted: { 
				required: errorPrefix + 'Please read and agree with the Notice at Collection before you proceed'
			},
            TermsOfEngagement: {
                required: function(){
                	$('.e_termsOfEngagement .e_questions').addClass('errorTerms');
                	return errorPrefix + i18n("js_valid_terms");
                }	  
            },
            CustomerDOB: {
                required: errorPrefix + i18n("js_valid_dob"),
                datepicker: errorPrefix + i18n("js_valid_dob"),
                dateMax: errorPrefix + i18n("js_valid_dob_18")
            },    
			DOBDay: {
				required: errorPrefix + i18n("js_valid_dobDay")
			},
			DOBMonth: {
				required: errorPrefix + i18n("js_valid_dobMonth")
			},
			DOBYear: {
				required: errorPrefix + i18n("js_valid_dobYear")
			},						 
			CustomerPassword:{
			    required: errorPrefix + i18n("js_valid_password")
            },
			userpassword:{
			    required: errorPrefix + i18n("js_valid_password")
            },
            Password:{required:errorPrefix + i18n("js_valid_password")}, //the password confirm on myAccount update
			CustomerConfirmPassword:{required: errorPrefix + i18n("js_valid_password_confirm")},
			userpasswordconfirm:{required: errorPrefix + i18n("js_valid_password_confirm")},
			CustomerPasswordChallenge:{required: errorPrefix + i18n("js_valid_security"),maxlength: errorPrefix + i18n("js_valid_length_max", {max: 100})},
			CustomerPasswordResponse:{required: errorPrefix + i18n("js_valid_security_answer")},
            CustomerTelephone1:{required: errorPrefix + i18n("js_valid_telephone")},
            CustomerEmail:{required: errorPrefix + i18n("js_valid_email")},
			useremail:{required: errorPrefix + i18n("js_valid_email")},
            CustomerLogin:{
			    required: errorPrefix + i18n("js_valid_username"),
                rangelength: errorPrefix + i18n("js_valid_username_range"),
				remote: "This username has been taken" // Default error message, replaced with message from server
			},
			username:{
			    required: errorPrefix + i18n("js_valid_username"),
                rangelength: errorPrefix + i18n("js_valid_username_range"),
				remote: "This username has been taken" // Default error message, replaced with message from server
			},
			CustomerCompanyName:{
				companyNameAllowedCharacters: errorPrefix + i18n("js_valid_chars") 
			}
		}
	};

	ele.validations.user ={
        ignore: ".ignore",
        rules:{
            userfirstname:{required:true,rangelength:[2,255]},
            userlastname:{required:true,rangelength:[2,255]},
            tokencode:{required:false,rangelength:[1,255]},
            username:{required:true,rangelength:[6,70],username:true},
            userpassword:{required:true,passwordCreate:true},
            userpasswordconfirm:{required:true,equalTo:':input[name="userpassword"]'},
            UserTermsAccepted:{required:true,maxlength: 2},
            useremail:{required:true,email: true},
        },
        messages:{
            userfirstname:{required: errorPrefix + i18n("js_valid_firstname")},
            userlastname:{required: errorPrefix + i18n("js_valid_lastname")},
            userpassword:{required: errorPrefix + i18n("js_valid_password")},
            userpasswordconfirm:{required: errorPrefix + i18n("js_valid_password_confirm")}
        }
    };
	
	ele.validations.referral={
		rules:{
			ReferralCategoryID:"required",
			ReferralText:{required:true,minlength:50}
		},
		messages:{
			ReferralCategoryID: errorPrefix + "Please complete the selections",
			ReferralText:{required: errorPrefix + "Please enter details of your enquiry",minlength: errorPrefix + "Your enquiry description must be longer than 50 characters"}
		}
	};
	
	ele.validations.customerMessage={
		rules:{
			customerfirstname:{required:true,rangelength:[2,255]},
			customerlastname:{required:true,rangelength:[2,255]},
			customeremail:{required:true,email:true,maxlength:70},
            customertelephone1:{phoneNumber:true},
            CustomerTelephone3:{phoneNumber:true},
			ticketcategoryid:"required",
			messagetext:{required:true,minlength:25,maxlength:3000}
		},
		messages:{
			customerfirstname:{required: errorPrefix + i18n('js_valid_firstname'), rangelength:errorPrefix + i18n('js_valid_length_range', {min:2, max: 255})},
			customerlastname:{required: errorPrefix + i18n('js_valid_lastname'),rangelength:errorPrefix + i18n('js_valid_length_range', {min:2, max: 255})},
			customeremail:{required: errorPrefix + i18n('js_valid_email'),email:errorPrefix + i18n('js_valid_email_invalid'),maxlength:errorPrefix + i18n('js_valid_length_max', {max: 70})},
			ticketcategoryid:{required: errorPrefix + i18n('js_valid_category')},
			messagetext:{
			    required: errorPrefix + i18n("js_valid_message"),
                minlength: errorPrefix + i18n('js_valid_length_min', {min: 25}),
                maxlength: errorPrefix + i18n('js_valid_length_max', {max: 3000})
			}
		}
	};

    ele.validations.uploads= {
        rules:{
            uploadedFileName: { required:true,rangelength:[2,255],noSpecialChars:true },
            uploadFile: { required: true }
        },
        messages: {
            uploadedFileName: {required:errorPrefix + i18n('js_valid_filename'),rangelength:errorPrefix + i18n('js_valid_length_range', {min:2, max: 255}),noSpecialChars:errorPrefix + "Some characters used are not allowed. Allowed characters A-Z 0-9 &()@#:.,/?+!*'_-"},
            uploadFile: {required:errorPrefix + i18n('js_valid_file')}
        }
    };
	ele.validations.uploadsReplace= {
        rules:{
			attachment: { required: true },
			filename: { required:true,rangelength:[2,255],noSpecialChars:true },
        },
        messages: {
			attachment: {required:errorPrefix + i18n('js_valid_file')},
			filename: {required:errorPrefix + i18n('js_valid_filename'),rangelength:errorPrefix + i18n('js_valid_length_range', {min:2, max: 255}),noSpecialChars:errorPrefix + "Some characters used are not allowed. Allowed characters A-Z 0-9 &()@#:.,/?+!*'_-"}
        }
    };

	
	/* I don't believe these two are used any more */
	
	ele.validations.creditcard={
		rules:{
			creditcardaccountholder:{required:true,noSpecialChars:false,rangelength:[2,60]},
			creditcardnumber:{required:true,digits:true},
			creditcardaddress:{required:true,rangelength:[10,255]},
			creditcardpostcode:{required:true,rangelength:[5,10]},
			creditcardtypeid:"required",
		    cardSecurityNumber:{required:true,rangelength:[3,4]}
			},
		messages:{
			creditcardaccountholder:{required:errorPrefix + "Enter the name on the card",noSpecialChars:errorPrefix + "You cannot use special characters. Alpha-numerics, underscores and periods only.",rangelength:errorPrefix + "The name on the card must be between 2 and 60 characters long"},
			creditcardnumber:{required:errorPrefix + "Enter the card number",digits:errorPrefix + "Numbers only in the credit card field"},
			creditcardaddress:{required:errorPrefix + "Enter the billing address details for the payment card",rangelength:errorPrefix + "The billing address must be between 10 and 255 characters long"},
			creditcardpostcode:{required:errorPrefix + "Enter the billing postcode for the payment card",rangelength:errorPrefix + "The billing address postcode must be between 5 and 9 characters long"},
			creditcardtypeid:errorPrefix + "Select the type of card",
			cardSecurityNumber:{required:errorPrefix + "Enter the 3 or 4 digit number on the back of the card", rangelength:errorPrefix + "Security number is 3 or 4 digits"}
		}
	};
	
	ele.validations.directdebit={
		rules:{
			isAccountHolder: { required: true },
			requiresTwoSignatures: { required: true },
			directdebitaccountholder1:{required:true,noSpecialChars:false,rangelength:[2,50]},
			directdebitaccountnumber:{required:true,digits:true,rangelength:[8,8]},
			directdebitsortcode:{required:true,digits:true,rangelength:[6,6]},
			directdebitbankname:{required:true,rangelength:[8,255]},
			directdebitbankaddress:{required:true,rangelength:[8,255]}
			},
		messages:{
			isAccountHolder: { required: errorPrefix + "Please select an option" },
			requiresTwoSignatures: { required: errorPrefix + "Please select an option" },
			directdebitaccountholder1:{required:errorPrefix + "Enter the bank account name",noSpecialChars:errorPrefix + "You cannot use special characters. Alpha-numerics, underscores and periods only.",rangelength:errorPrefix + "The bank account name must be between 2 and 50 characters long"},
			directdebitaccountnumber:{required:errorPrefix + "Enter the bank account number",rangelength:errorPrefix + "Account number must be 8 digits"},
			directdebitsortcode:{required:errorPrefix + "Enter the bank account sort code",rangelength:errorPrefix + "Sort code must be 6 digits"},
			directdebitbankname:{required:errorPrefix + "Enter the bank name",rangelength:errorPrefix + "The bank name must be between 8 and 255 characters long"},
			directdebitbankaddress:{required:errorPrefix + "Enter the bank address",rangelength:errorPrefix + "The bank address must be between 8 and 255 characters long"}
			}
	};
	
	ele.validations.sewin={
		rules:{
			sewinmembershipnumber:"required",
			sewinvalidator:{required:true,noSpecialChars:false}
		},
		messages:{
			sewinmembershipnumber: errorPrefix + i18n('js_valid_policynumber'),
			sewinvalidator: errorPrefix + i18n('js_required')
		}
	};
	
	ele.validations.PasswordReminder={
		rules:{
			CustomerEmail:{required:true,email:true}	
		},
		messages:{
			CustomerEmail:{required:errorPrefix + i18n('js_valid_email'), email:errorPrefix + i18n('js_valid_email_invalid')}
		}
	};

    ele.validations.PasswordReset = {
        rules: {
            OriginalPassword:"required",
            NewPassword: {required:true, passwordCreate:true},
            ConfirmPassword:{required:true,	equalTo:"#NewPassword"}
        },
        messages: {
            OriginalPassword:errorPrefix + i18n('js_valid_password_current'),
            NewPassword:{
                required:errorPrefix + i18n('js_valid_password')
            },
            ConfirmPassword: {
                required:errorPrefix + i18n('js_valid_password_confirm'),
                equalTo: errorPrefix + i18n('js_valid_match')
            }
        }
    };

	ele.validations.PasswordChallenge={
		rules:{
			CustomerPasswordResponse:{required:true}	
		},
		messages:{
			CustomerPasswordResponse:{required:errorPrefix + i18n('js_valid_security_answer')}
		}
	};

	ele.validations.ChangeSecurityQuestion={
		rules: {
			CustomerPasswordResponse: {required:true,securityAnswer:true,password:false},
			password: true,
			changeSecurityQsQuestionList: {required:true}
		},	
        messages: {
            CustomerPasswordResponse: ele.validations.customer.messages.CustomerPasswordResponse,
            password:errorPrefix +  i18n('js_valid_password_current'),
            changeSecurityQsQuestionList: errorPrefix + i18n('js_valid_security')
        }
	};
	
	ele.validations.LegalReview={
		rules:{
			otherParty_1_Name:{required: true},
			otherParty_1_Address:{required: true,rangelength:[10,255]},
			otherParty_1_Email:{email:true, maxlength:70}, 
			otherParty_1_Telephone:{required: true, minlength:10, maxlength:20, phoneNumber:true},
			otherParty_1_DOB:{required: true, date: true}
		},
		messages:{
			otherParty_1_Name:{required: errorPrefix + i18n('js_valid_otherparty_name')},
			otherParty_1_Address:{required: errorPrefix + i18n('js_valid_otherparty_email'),rangelength:errorPrefix + i18n('js_valid_length_range', {min:10, max: 255})},
			otherParty_1_Email:{email:errorPrefix + i18n('js_valid_email_invalid'), maxlength:errorPrefix + i18n('js_valid_length_max', {max: 70})},
			otherParty_1_Telephone:{required: errorPrefix + i18n('js_valid_otherparty_telephone')},
			otherParty_1_DOB:{required: errorPrefix + i18n('js_valid_otherparty_dob')}
		}
	};

	ele.validations.referral_usa={
		rules: {
			full_name:{required: true},
			jurisdictionID:{required: true, notDefaultValue: "-"},
			contact_no:{required: true},
			email_address:{email:true}, 
			address: {required: true},			
			detail:{required: true},
			description:{required: true}
		}, 
		messages: {
			full_name:{required: "Full name is required"},
			jurisdictionID: { 
				required: "Jurisdiction is required", 
				notDefaultValue: "Please select a jurisdiction" 
			},			
			contact_no:{required: "Contact number is required"},
			email_address:{required: "Email address is required"},
			address: {required: "Address is required"},
			detail:{required: "Please enter details of your legal matter"},
			description: {required: "A summary title is required"} 
		}
	};

	$.extend($.validator.messages, {
	    required: errorPrefix + i18n("js_required"),
	    email: errorPrefix + i18n("js_valid_email_invalid"),
	    date: errorPrefix + i18n("js_valid_date", {dateformat: ele.config.usersession.dateformat}),
	    number: errorPrefix + i18n("js_valid_number"),
	    equalTo: errorPrefix + i18n("js_valid_match"),
	    maxlength: jQuery.validator.format(errorPrefix + i18n("js_valid_length_max", {max: "{0}"})),
	    minlength: jQuery.validator.format(errorPrefix + i18n("js_valid_length_min", {min: "{0}"})),
	    rangelength: jQuery.validator.format(errorPrefix + i18n("js_valid_length_range", {min: "{0}", max: "{1}"})),
	});
	
});